<template>
  <div
    class="file-viewer-image-list-wrapper"
    :class="{ fullscreen, folded, maximized }"
  >
    <div class="thumb-wrapper">
      <div
        v-if="maximized || fullscreen"
        class="thumb-toggle"
        @click="showThumbs = !showThumbs"
      >
        <i
          class="iconfont"
          :class="[
            showThumbs ? 'icon-zuocefanhuijiantou' : 'icon-youcefanhuijiantou'
          ]"
        ></i>
      </div>
      <swiper
        v-show="showThumbs"
        ref="thumbSwiper"
        :options="thumbSwiperOptions"
        class="thumb-swiper"
        @ready="onThumbReady"
        @touchStart="onTouchStart"
      >
        <swiper-slide v-for="item in viewFile" :key="item">
          <div class="thumb-item">
            <img :src="item" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="content-wrapper">
      <div class="preview-wrapper" @mousewheel.stop>
        <swiper
          v-if="initPreviewSwiper"
          ref="previewSwiper"
          :options="previewSwiperOptions"
          class="preview-swiper"
          @slideChange="updateThumb"
          @touchStart="onTouchStart"
        >
          <swiper-slide v-for="item in viewFile" :key="item">
            <div
              class="preview-item"
              @mousewheel.stop
              @click="onPreviewItemClick(item)"
            >
              <img :src="item" />
            </div>
          </swiper-slide>
          <div slot="pagination" class="swiper-pagination"></div>
        </swiper>
        <div class="action-buttons">
          <button class="fullscreen-btn" @click="fullscreenToggle()">
            <i
              class="iconfont"
              :class="[fullscreen ? 'icon-quanpingguanbi' : 'icon-quanping']"
            ></i>
            <div class="tooltip">
              {{ fullscreen ? '退出全屏' : '全屏查看' }}
            </div>
          </button>
        </div>
      </div>
      <div v-if="maximized" class="restore-button" @click="restore">
        <i class="iconfont icon-guanbianniu"></i>
      </div>
      <div
        v-if="fullscreen"
        class="restore-button"
        @click="fullscreenToggle(true)"
      >
        <i class="iconfont icon-guanbianniu"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

const thumbActiveClass = 'thumb-active'

export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {
    // 图片列表
    viewFile: {
      type: Array,
      default: () => []
    },
    // 该单个文件是否允许下载
    singleDownloadable: Boolean,
    maximized: Boolean,
    fullscreen: Boolean
  },
  data() {
    return {
      // 当前文件
      current: 0,
      // 左侧的当前状态，是否收起
      folded: false,
      initPreviewSwiper: false,
      autoScrollOffset: 2,
      exitToOriginal: false,
      thumbSwiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 8,
        direction: 'vertical',
        mousewheel: true,
        updateOnWindowResize: true,
        freeMode: true,
        watchSlidesVisibility: true
      },
      previewSwiperOptions: {
        direction: 'vertical',
        mousewheel: true,
        updateOnWindowResize: true,
        thresholdTime: 1000,
        observer: true,
        observeParents: true,
        keyboard: {
          enable: true
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        }
      },
      showThumbs: true
    }
  },
  computed: {
    thumbSwiper() {
      return this.$refs.thumbSwiper.swiper
    },
    previewSwiper() {
      return this.$refs.previewSwiper.swiper
    }
  },
  methods: {
    onThumbReady() {
      const { thumbSwiper, previewSwiperOptions } = this
      previewSwiperOptions.thumbs = {
        swiper: thumbSwiper
      }
      thumbSwiper.slides.eq(0).addClass(thumbActiveClass)
      this.initPreviewSwiper = true
    },
    onPreviewItemClick() {
      if (!this.maximized) {
        this.autoScrollOffset = 3
        this.$emit('maximize')
      }
    },
    updateThumb() {
      const { thumbSwiper, previewSwiper, autoScrollOffset } = this
      const index = previewSwiper.realIndex
      thumbSwiper.slides.removeClass(thumbActiveClass)
      thumbSwiper.slides.eq(index).addClass(thumbActiveClass)
      thumbSwiper.slideTo(index - autoScrollOffset)
    },
    restore() {
      this.autoScrollOffset = 2
      this.showThumbs = true
      this.$emit('restore')
    },
    fullscreenToggle(original = false) {
      this.exitToOriginal = original
      this.$emit('fullscreen', fullscreen => {
        if (!fullscreen && this.exitToOriginal) {
          this.restore()
        }
      })
    },
    onTouchStart() {
      const { previewSwiper, thumbSwiper } = this
      previewSwiper.allowTouchMove = true
      previewSwiper.thumbs.swiper = thumbSwiper
    }
  }
}
</script>

<style lang="scss" scoped>
.file-viewer-image-list-wrapper {
  &,
  .swiper-container,
  .preview-wrapper,
  .content-wrapper {
    height: 100%;
    position: relative;
  }
  .swiper-slide {
    width: auto;
    height: auto;
  }
  .preview-wrapper {
    background-color: #000000;
    overflow: hidden;
    position: relative;
    .swiper-pagination {
      position: absolute;
      background-color: rgba(54, 54, 54, 0.85);
      z-index: 10;
      left: 25px;
      bottom: 12px;
      width: auto;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      padding: 0 12px;
    }
    .action-buttons {
      position: absolute;
      right: 4px;
      bottom: 12px;
      z-index: 10;
      button {
        width: 40px;
        height: 40px;
        background-color: rgba(54, 54, 54, 0.85);
        color: #ffffff;
        border: none;
        outline: none;
        float: left;
        margin-right: 20px;
        border-radius: 0;
        cursor: pointer;
        position: relative;
        &:hover {
          background-color: #3352fe;
          .tooltip {
            display: block;
          }
        }
        .tooltip {
          position: absolute;
          font-size: 12px;
          white-space: nowrap;
          background-color: #363636;
          top: 0;
          left: 50%;
          width: 72px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          margin: -30px 0 0 -36px;
          border-radius: 3px;
          display: none;
        }
      }
      .download-btn {
        i {
          font-size: 22px;
        }
      }
    }
  }
  .thumb-wrapper {
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    float: left;
    box-sizing: border-box;
    position: relative;
    .swiper-slide-thumb-active,
    .thumb-active {
      .thumb-item {
        border: 5px solid #3352fe;
      }
    }
    .thumb-toggle {
      position: absolute;
      right: -15px;
      top: 50%;
      margin-top: -26px;
      width: 16px;
      height: 52px;
      line-height: 52px;
      font-size: 12px;
      color: #8e9091;
      background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAA0CAYAAAH0yYjXAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAEKADAAQAAAABAAAANAAAAAAj3NoMAAABY0lEQVRIDWMwNzd/yQAEjGZmZv9BDCYQAQLEMBgsLCzMQYrJ0w7XBTICBOB2QrjUEWAA+nECzEAQTR9raeIXFEMZGRlfYvgF5lGg5GV2dnZvFB0wSRD9//9/3R8/fjzCqQCmeFQBJCQIhgMLLMRANDD87wPxciYmpuXHjh27AhJjBqbEvdLS0qyqqqq3Hzx48AskiAxwxeZvoClTTpw4UYRLAdgQoHUb8DoSGOUBeBWAjBlVAImR0XCgSzgAE+0nQkFtgqzgP1DHJiCONDAwYDt16hTjyZMnb+PKFyDFD4D+uAykrwCT/2UWFpbL2trat2bNmvUb4j8IicsAZDVY2UCDQRWoLbITsSrEJQh0lThQ7gzZBoAMBhrCR5EBIENGDRgNg9F0AAqB0XQwDMIAWDJvQGmSgSMWP/EbqOkGEO9hY2PrP3To0GMWIOcVUA+o/QauREA0BwfH1QMHDnzBbxZEFgDJC13AjvQ1vwAAAABJRU5ErkJggg==')
        no-repeat center/100% 100%;
      border-radius: 3px 0 0 3px;
      cursor: pointer;
      z-index: 10;
      &:hover {
        color: #ffffff;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAABoCAYAAAHndsJjAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAaAAAAADnzVNBAAAC00lEQVRoBe1av2/TQBR+n92CBIEBBiYGmNmCxF/QgYWhnWDgXwCJhRWJhQUhRiYEUp2oSReQYKhEJQYKxFMcCTFAEVNhANEuqD+O95y4uji+C66RLKoXybHv7t3n7z7fu/O7MzXnzQZZPzTn94yVpsBOyPX/k0HNBXPJpn+YGjfRlqyhAFZ6Xcw5DTLDiQeZFWRnNRgqMVWHmUyxsTNwI+7iYZrHPfHBWGEu4XxYCHC110HLaSBAIOx4SRoyM14DQVEDUUF1GKpQvw48kN0v8CysHQvpyuslfBeibr8A+oGhKDxC0VoL61mr8mc3QN6yIH0+xNGpblNQbz/r0675XQlAkBRANdB+MPQp9QX1hWq+EOB2vBxgbObhqegz8WRCsxT12kiGfc3/j4sLZkUqNUJqry5hy28+WVo8MwHbIOrwEb3r0HNmNhau2TDFALaFdc3vkBIIRo2TdGf1MX5KUSln4nfMM3zc3PxlfnDTnwhAKQZSwf4FwIVSDOzKcm0MvagGQOZsJQBhoQCqgfYDUUD7gWqQdgMdE9UX0o6gc6OOiYdgTOSX8N2qXXmxEgAv+F8/GACwJeGOPIWxkCf1z9wfxwibHG20OXsxXsarXLENAMOQz3igj8wp6saPsJ03Lko74gUGA61zLNXnpW45Eg56+nun6ePfAhfdrCjPQaDI1J03kmmQkiVKhDivWSbZmqW7ZsWIyQdcWMYPn0nejTu4l5X/EwUysDJnWe7lbnyrNgJClkk8PZgflWmq3/ZarQSMMWGtBEQcJaAKqAKqgCqgCqgCqoAqoAqoAqqAKqAKqAKqgCqgCqgCtSrAi9xfayPAN9/hLYHLtRCQNeJzIR1/38Vg6paJf6nXX8qt3JDNjnTjI6C3jQa9zD7N6o2qliPAH49xvQ+8NZPuoAh4OEv9NxF94VY5PyTz0WQC+MYGSbrbMWJ7IqBBmU/e0PLdwl/2Bw2YwPzJt6zvAAAAAElFTkSuQmCC');
      }
    }
    .thumb-swiper {
      padding: 8px;
    }
  }
  .thumb-item {
    overflow: hidden;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 100%;
      float: left;
      object-fit: cover;
    }
  }
  .preview-item {
    width: 100%;
    height: 100%;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    img {
      max-width: 100%;
      max-height: 100%;
      border-radius: 8px;
    }
  }
  .thumb-item {
    width: 134px;
    height: 75px;
  }
  &.with-list {
    .preview-item {
      padding: 21px 12px;
    }
  }
  .restore-button {
    position: absolute;
    top: 32px;
    right: 32px;
    width: 56px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    border-radius: 50%;
    color: #363636;
    background-color: rgba(142, 144, 145, 0.85);
    z-index: 10;
    cursor: pointer;
    .iconfont {
      font-size: 35px;
    }
    &:hover {
      background-color: #3352fe;
      color: #ffffff;
    }
  }
  &.maximized,
  &.fullscreen {
    .preview-item {
      padding: 24px;
    }
    .preview-wrapper {
      background-color: rgba(0, 0, 0, 0.85);
    }
    .thumb-wrapper {
      background-color: #363636;
    }
  }
  .fullscreen-btn {
    i {
      font-size: 20px;
    }
  }
}
</style>
